<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text" >车位号编码前缀：</span>
        </div>
        <el-input v-model="formData.numberPrefix" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">起始编号：</span>
        </div>
        <el-input v-model="formData.startNumber" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">结束编号：</span>
        </div>
        <el-input v-model="formData.endNumber" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text" style="width:500px;display:inline-block;margin-left:-44px">填充<el-tooltip class="tip" effect="light" content="如车位号编码前缀为P,起始编号为1，结束编号为100，填充为000，则自动转化为:P001、P002~P099、P100" placement="right-start"><i class="el-icon-question" /></el-tooltip>：</span>
        </div>
        <el-input v-model="formData.fillCode" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位区域：</span>
        </div>
        <el-select v-model="areaCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择车位区域">
          <el-option v-for="item in parkingLotAreaList" :key="item.code"
                     :label="item.parkingLotAreaName" :value="item.code">
          </el-option>
        </el-select>              
      </div>  


      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "parking-lot-add-many",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车位管理"
        }
      ],
      mainTitle: "批量添加车位",
      subheading: "",

      inDeviceList: [],
      outDeviceList: [],
      typeList: [{ code: "true", name: "是" }, { code: "false", name: "否" }],
      formData: {
        numberPrefix: "",
        startNumber: "",
        endNumber: "",
        fillCode: "",
        status: 0
      },
      parkingLotAreaList: [],
      areaCode: ""
    };
  },

  created() {
    this.remoteMethod();
  },
  methods: {
    remoteMethod() {
      this.getParkingLotAreaList();
    },

    // 确认添加
    confirm() {
      if (!this.formData.numberPrefix) {
        nError("请输入车位号前缀");
        return false;
      }
      if (!this.formData.startNumber) {
        nError("请输入起始编号");
        return false;
      }
      if (!this.formData.endNumber) {
        nError("请输入结束编号");
        return false;
      }
      if (!this.formData.areaCode) {
        nError("请选择车位区域");
        return false;
      }
      this.$axios
        .post(api.addParkingLot, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "parking-lot-manage"
            });
          }
        })
        .catch(errorHandler());
    },
    cancel() {
      this.$router.push({
        name: "parking-lot-manage"
      });
    },
    getParkingLotAreaList() {
      this.$axios
        .post(api.getParkingLotAreaList, {})
        .then(res => {
          this.parkingLotAreaList = res.data.data;
        })
        .catch(errorHandler("获取车位区域列表失败"));
    }
  },
  watch: {
    areaCode(val) {
      console.log(val);
      this.parkingLotAreaList.map(v => {
        if (v.code == val) {
          this.formData.areaName = v.parkingLotAreaName;
          this.formData.areaCode = v.code;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.tip {
  color: #3c44c0;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingLot/ParkingLotAddMany.vue